// src/pages/NotFound.jsx
import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-green-900">404</h1>
        <p className="text-xl text-slate-600 mt-4">Page non trouvée</p>
        <Link 
          to="/login" 
          className="inline-block mt-6 px-6 py-3 bg-green-900 text-white rounded-lg hover:bg-slate-800 transition"
        >
          Retour à l'accueil
        </Link>
      </div>
    </div>
  );
}